"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalEllipsesIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const VerticalEllipsesIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "5", height: "20", viewBox: "0 0 5 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M2.18213 4.41675C3.3298 4.41675 4.25 3.48621 4.25 2.31787C4.25 1.18054 3.3298 0.25 2.18213 0.25C1.03446 0.25 0.114263 1.18054 0.114262 2.31787C0.114262 3.48621 1.03446 4.41675 2.18213 4.41675ZM2.18213 12.0679C3.3298 12.0679 4.25 11.1477 4.25 10C4.25 8.86267 3.3298 7.94247 2.18213 7.94247C1.03446 7.94247 0.114262 8.86267 0.114262 10C0.114262 11.1477 1.03446 12.0679 2.18213 12.0679ZM2.18213 19.75C3.3298 19.75 4.25 18.8298 4.25 17.6821C4.25 16.5138 3.3298 15.5936 2.18213 15.5936C1.03446 15.5936 0.114262 16.5138 0.114262 17.6821C0.114262 18.8298 1.03446 19.75 2.18213 19.75Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }) })));
};
exports.VerticalEllipsesIcon = VerticalEllipsesIcon;
//# sourceMappingURL=vertical_ellipses_icon.js.map